module.exports = __webpack_public_path__ + "img/cases-brand-illumcare-0.28e30fb5.jpg";